// #### Recipes ####
export const LeuteRecipe = {
    $type$: 'Recipe',
    name: 'Leute',
    rule: [
        {
            itemprop: 'appId',
            itemtype: { type: 'string', regexp: /^one.leute$/ },
            isId: true
        },
        {
            itemprop: 'me',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Someone']) }
        },
        {
            itemprop: 'other',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToId', allowedTypes: new Set(['Someone']) }
            }
        },
        {
            itemprop: 'group',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToId', allowedTypes: new Set(['GroupProfile']) }
            }
        }
    ]
};
export default [LeuteRecipe];
//# sourceMappingURL=Leute.js.map